module.exports = __webpack_public_path__ + "static/media/08.77f94f26.jpg";